import { render, staticRenderFns } from "./AppHeaderComponent.vue?vue&type=template&id=e59cdb2c&scoped=true&"
import script from "./AppHeaderComponent.vue?vue&type=script&lang=ts&"
export * from "./AppHeaderComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59cdb2c",
  null
  
)

export default component.exports